<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div>
          <div class="container">
            <div class="main-golfClubBatteryStatus">
              <div class="golfClubBatteryStatus-header">
                <h3 class="title">
                  <div class="item">
                    {{ clubInfo.club_name }}
                  </div>
                </h3>
                <div class="date">
                  <div class="item">
                    {{ aplCommBatteryData.club.updateAt | formatDateTime }}
                  </div>
                </div>
              </div>
              <div class="golfClubBatteryStatus-body">
                <!--                <div class="info golfClubInfo">-->
                <!--                  &lt;!&ndash; 데이터 없을때(Class) : none &ndash;&gt;-->
                <!--                  <div class="body">-->
                <!--                    <div class="table thead">-->
                <!--                      &lt;!&ndash; 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 &ndash;&gt;-->
                <!--                      <div class="fixed" style="margin-left: -0px;">-->
                <!--                        <div class="contain">-->
                <!--                          <table>-->
                <!--                            <colgroup>-->
                <!--                              <col class="course" />-->
                <!--                              <col class="normal" />-->
                <!--                              <col class="abnormal" />-->
                <!--                              <col class="normalOperationRate" />-->
                <!--                              <col class="spareParts" />-->
                <!--                              <col class="pin" />-->
                <!--                              <col class="pinChangeSystem" />-->
                <!--                            </colgroup>-->
                <!--                            <thead>-->
                <!--                            <tr>-->
                <!--                              <th class="course first">-->
                <!--                                <div class="item">-->
                <!--                                  코스-->
                <!--                                </div>-->
                <!--                              </th>-->
                <!--                              <th class="course normal">-->
                <!--                                <div class="item">-->
                <!--                                  정상-->
                <!--                                </div>-->
                <!--                              </th>-->
                <!--                              <th class="course abNormal">-->
                <!--                                <div class="item">-->
                <!--                                  비정상-->
                <!--                                </div>-->
                <!--                              </th>-->
                <!--                              <th class="course normalOperationRate">-->
                <!--                                <div class="item">-->
                <!--                                  정상 가동률-->
                <!--                                </div>-->
                <!--                              </th>-->
                <!--                              <th class="course spareParts">-->
                <!--                                <div class="item">-->
                <!--                                  예비품-->
                <!--                                </div>-->
                <!--                              </th>-->
                <!--                              <th class="course pin">-->
                <!--                                <div class="item">-->
                <!--                                  핀 규격-->
                <!--                                </div>-->
                <!--                              </th>-->
                <!--                              <th class="course pinChangeSystem">-->
                <!--                                <div class="item">-->
                <!--                                  핀 교체 방식-->
                <!--                                </div>-->
                <!--                              </th>-->
                <!--                            </tr>-->
                <!--                            </thead>-->
                <!--                          </table>-->
                <!--                        </div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                    <div class="table tbody">-->
                <!--                      <div class="contain">-->
                <!--                        <table>-->
                <!--                          <colgroup>-->
                <!--                            <col class="course" />-->
                <!--                            <col class="normal" />-->
                <!--                            <col class="abnormal" />-->
                <!--                            <col class="normalOperationRate" />-->
                <!--                            <col class="spareParts" />-->
                <!--                            <col class="pin" />-->
                <!--                            <col class="pinChangeSystem" />-->
                <!--                          </colgroup>-->
                <!--                          <tbody>-->
                <!--                          <tr>-->
                <!--                            <td class="course first bottomLeft">-->
                <!--                              {{currentNHole}}-->
                <!--                            </td>-->
                <!--                            <td class="normal">-->
                <!--                              {{currentActiveCount}}-->
                <!--                            </td>-->
                <!--                            <td class="abnormal">-->
                <!--                              {{currentInactiveCount}}-->
                <!--                            </td>-->
                <!--                            <td class="normalOperationRate">-->
                <!--                              {{Percentage(currentActiveCount , currentActiveCount + currentInactiveCount)}}-->
                <!--                            </td>-->
                <!--                            <td class="spareParts">-->
                <!--                              {{currentIdleCount}}-->
                <!--                            </td>-->
                <!--                            <td class="pin">-->
                <!--                              {{confirmPinSize(clubInfo.pin_size)}}-->
                <!--                            </td>-->
                <!--                            <td class="pinChangeSystem bottomRight">-->
                <!--                              {{clubInfo.pin_change}}-->
                <!--                            </td>-->
                <!--                          </tr>-->
                <!--                          </tbody>-->
                <!--                          <tbody class="none">-->
                <!--                          <tr>-->
                <!--                            <td colspan="10">-->
                <!--                              데이터가 없습니다.-->
                <!--                            </td>-->
                <!--                          </tr>-->
                <!--                          </tbody>-->
                <!--                        </table>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!-- New table -->
                <div class="pin-conditions">
                  <table class="pin-conditions__table">
                    <thead class="table__head">
                      <tr>
                        <th>코스</th>
                        <th>정상</th>
                        <th>비정상</th>
                        <th>휴장홀</th>
                        <th>정상 가동률</th>
                        <th>예비품</th>
                        <th>핀 규격</th>
                        <th>핀 교체 방식</th>
                      </tr>
                    </thead>
                    <tbody class="table__body">
                      <tr>
                        <td>{{ pinConditions.holeCount }}</td>
                        <td>{{ pinConditions.normalCount }}</td>
                        <td>{{ currentInactiveCount }}</td>
                        <td>{{ currentHolidayHoleCount }}</td>
                        <td>{{ pinConditions.normalOperationRate }}</td>
                        <td>{{ pinConditions.spareCount }}</td>
                        <td>{{ pinConditions.pinStandard }}</td>
                        <td>{{ pinConditions.pinMethod }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="info batteryInfo">
                  <!-- 데이터 없을때(Class) : none -->
                  <div
                    class="body"
                    :class="{
                      none: isBatteryDataEmpty
                    }"
                  >
                    <div class="table thead">
                      <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                      <div class="fixed" style="margin-left: -0px;">
                        <div class="contain">
                          <table>
                            <colgroup>
                              <col class="course" />
                              <col class="green" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                              <col class="num" />
                              <col class="status" />
                            </colgroup>
                            <thead>
                              <tr>
                                <th colspan="2" class="course first">
                                  <div class="item">
                                    코스
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    1
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    2
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    3
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    4
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    5
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    6
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    7
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    8
                                  </div>
                                </th>
                                <th colspan="2" class="course">
                                  <div class="item">
                                    9
                                  </div>
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="table tbody">
                      <div class="contain">
                        <table>
                          <colgroup>
                            <col class="course" />
                            <col class="green" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                          </colgroup>
                          <tbody>
                            <template
                              v-for="(courseBattery,
                              courseIndex) in aplBatteryList"
                            >
                              <template
                                v-for="(aplList,
                                aplListIndex) in courseBattery.aplListL"
                              >
                                <tr
                                  v-if="
                                    (courseIndex !== 0 || aplListIndex !== 0) &&
                                      courseBattery.courseCycle > 1
                                  "
                                  :key="'' + courseIndex + aplListIndex + 1"
                                >
                                  <td
                                    class="first"
                                    :class="{
                                      bottomLeft:
                                        courseIndex ===
                                        aplBatteryList.length - 1
                                    }"
                                    :rowspan="
                                      courseBattery.rowSpan -
                                        (hasRight
                                          ? 0
                                          : 1 * courseBattery.courseCycle)
                                    "
                                    :colspan="hasRight ? 1 : 2"
                                    v-if="aplListIndex === 0"
                                  >
                                    {{ courseBattery.name }}
                                  </td>
                                  <th v-if="hasRight">
                                    <div class="item"></div>
                                  </th>
                                  <th
                                    colspan="2"
                                    v-for="i in 9"
                                    :key="i"
                                    class="course"
                                  >
                                    <div class="item">
                                      {{ aplListIndex * 9 + i }}
                                    </div>
                                  </th>
                                </tr>
                                <tr :key="'' + courseIndex + aplListIndex + 2">
                                  <td
                                    class="first"
                                    :class="{
                                      bottomLeft:
                                        courseIndex ===
                                        aplBatteryList.length - 1
                                    }"
                                    :rowspan="
                                      courseBattery.rowSpan -
                                        (hasRight
                                          ? 0
                                          : 1 * courseBattery.courseCycle) -
                                        1
                                    "
                                    :colspan="hasRight ? 1 : 2"
                                    v-if="
                                      (aplListIndex === 0 &&
                                        courseIndex === 0) ||
                                        courseBattery.courseCycle === 1
                                    "
                                  >
                                    {{ courseBattery.name }}
                                  </td>
                                  <td class="green" v-if="hasRight">
                                    L
                                  </td>
                                  <template v-for="(apl, j) in aplList">
                                    <td
                                      class="num"
                                      :colspan="!apl ? 2 : 1"
                                      :key="'' + j + 1"
                                    >
                                      <div v-if="apl">
                                        {{ apl.aplId }}
                                      </div>
                                    </td>
                                    <!-- 배터리 잔량(Class) : 0~20% : battery-20 / 21~40% : battery-40 / 41~60% : battery-60 / 61~80% : battery-80 / 81~100% : battery-100 -->
                                    <!-- 경고(Class) : statusWarning -->
                                    <!-- 핀뒤집힘(Class) : statusPinError -->
                                    <td
                                      class="status"
                                      :class="[
                                        setBarClass(
                                          apl.hlidx,
                                          apl.battery,
                                          apl.isAngleAbnormal
                                        ),
                                        {
                                          bottomRight:
                                            !hasRight &&
                                            j === aplList.length - 1
                                        }
                                      ]"
                                      v-if="apl"
                                      :key="'' + j + 2"
                                    >
                                      <div class="batteryGauge">
                                        <i></i>
                                        <div class="battery">
                                          <div class="bar">
                                            <div class="item">
                                              배터리 잔량
                                            </div>
                                          </div>
                                        </div>
                                        <div class="percent">
                                          {{ convertBatteryText(apl.battery) }}
                                        </div>
                                      </div>
                                      <div class="warning">
                                        <div class="box">
                                          배터리 경고
                                        </div>
                                      </div>
                                      <div class="pinError">
                                        <div class="box">
                                          핀 뒤집힘
                                        </div>
                                      </div>
                                      <div class="closed">
                                        <div class="box">
                                          휴장홀
                                        </div>
                                      </div>
                                    </td>
                                  </template>
                                </tr>
                                <tr
                                  v-if="hasRight"
                                  :key="'' + courseIndex + aplListIndex + 3"
                                >
                                  <td class="green">
                                    R
                                  </td>
                                  <template
                                    v-for="(apl, j) in courseBattery.aplListR[
                                      aplListIndex
                                    ]"
                                  >
                                    <td
                                      class="num"
                                      :class="{
                                        bottomRight:
                                          courseIndex ===
                                            aplBatteryList.length - 1 &&
                                          j ===
                                            courseBattery.aplListR[aplListIndex]
                                              .length -
                                              1 &&
                                          !apl
                                      }"
                                      :colspan="!apl ? 2 : 1"
                                      :key="'' + j + 1"
                                    >
                                      <div v-if="apl">
                                        {{ apl.aplId }}
                                      </div>
                                    </td>
                                    <!-- 배터리 잔량(Class) : 0~20% : battery-20 / 21~40% : battery-40 / 41~60% : battery-60 / 61~80% : battery-80 / 81~100% : battery-100 -->
                                    <!-- 경고(Class) : statusWarning -->
                                    <td
                                      class="status"
                                      :class="[
                                        setBarClass(
                                          apl.hlidx,
                                          apl.battery,
                                          apl.isAngleAbnormal
                                        ),
                                        {
                                          bottomRight:
                                            courseIndex ===
                                              aplBatteryList.length - 1 &&
                                            j ===
                                              courseBattery.aplListR[
                                                aplListIndex
                                              ].length -
                                                1
                                        }
                                      ]"
                                      v-if="apl"
                                      :key="'' + j + 2"
                                    >
                                      <div class="batteryGauge">
                                        <i></i>
                                        <div class="battery">
                                          <div class="bar">
                                            <div
                                              class="item"
                                              :style="{
                                                width: `${Math.ceil(
                                                  apl.battery / 2
                                                )}px`
                                              }"
                                            >
                                              배터리 잔량
                                            </div>
                                          </div>
                                        </div>
                                        <div class="percent">
                                          {{ convertBatteryText(apl.battery) }}
                                        </div>
                                      </div>
                                      <div class="warning">
                                        <div class="box">
                                          배터리 경고
                                        </div>
                                      </div>
                                      <div class="pinError">
                                        <div class="box">
                                          핀 뒤집힘
                                        </div>
                                      </div>
                                    </td>
                                  </template>
                                </tr>
                              </template>
                            </template>
                          </tbody>
                          <tbody class="none">
                            <tr>
                              <td colspan="20">
                                데이터가 없습니다.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="info keepInfo">
                  <!-- 데이터 없을때(Class) : none -->
                  <div
                    class="body"
                    :class="{
                      none: idleList !== null && !idleList.length
                    }"
                  >
                    <div class="table">
                      <div class="contain">
                        <table>
                          <colgroup>
                            <col class="keep" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                            <col class="num" />
                            <col class="status" />
                          </colgroup>
                          <tbody>
                            <template v-for="(idle, i) in idleList">
                              <tr :key="'' + i + 1">
                                <th
                                  :rowspan="idle.length * 2"
                                  class="keep first"
                                  v-if="i === 0"
                                >
                                  보관
                                </th>
                                <th
                                  v-for="j in 9"
                                  :key="j"
                                  colspan="2"
                                  :style="{
                                    'border-top':
                                      i !== 0 ? '1px solid #e6e6e6' : 'none'
                                  }"
                                  class="course"
                                >
                                  {{ i * 9 + j }}
                                </th>
                              </tr>
                              <tr :key="'' + i + 2">
                                <template v-for="(apl, j) in idle">
                                  <td
                                    class="num"
                                    :colspan="apl ? 1 : 2"
                                    :key="'' + i + j + 1"
                                  >
                                    <div v-if="apl">
                                      {{ apl.apl_id }}
                                    </div>
                                  </td>
                                  <!-- 충전중(Class) : statusCharging / 충전완료(Class) : statusComplete -->
                                  <td
                                    class="status"
                                    :class="{
                                      bottomRight:
                                        i === idleList.length - 1 &&
                                        j === idle.length - 1
                                    }"
                                    v-if="apl"
                                    :key="'' + i + j + 2"
                                  >
                                    <div class="batteryGauge">
                                      <div class="battery">
                                        <div class="bar">
                                          <div
                                            class="item"
                                            :style="{
                                              width: `${convertBatteryValue(
                                                apl.battery
                                              )}%`
                                            }"
                                          >
                                            배터리 잔량
                                          </div>
                                        </div>
                                      </div>
                                      <div class="percent">
                                        {{ convertBatteryText(apl.battery) }}
                                      </div>
                                    </div>
                                  </td>
                                </template>
                              </tr>
                            </template>
                          </tbody>
                          <tbody class="none">
                            <tr>
                              <td colspan="19">
                                데이터가 없습니다.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
    </div>
  </div>
</template>

<script>
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import { gcsService, settingService, userService } from '../../router'

export default {
  name: 'CD002',
  data() {
    return {
      aplBatteryList: null,
      hasRight: 0,
      idleList: null,
      aplCommBatteryData: {
        courseList: [],
        club: [],
        battery: {
          activeApl: [],
          idleApl: []
        }
      },
      clubInfo: [],
      isDataExist: 0,
      showBatteryData: [],
      currentNHole: 0,
      currentActiveCount: 0,
      currentSetupCount: 0,
      currentInactiveCount: 0,
      currentIdleCount: 0,
      currentHolidayHoleCount: 0,
      courseCnt: 0,
      fieldCnt: 0,
      showIdleData: []
    }
  },
  created: function() {
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.userInfo.userRole === 'ClubManager') {
        this.currentClubCode = this.userInfo.ccode
      } else {
        if (this.$route.query.ccode === undefined) {
          this.moveMenu('/CD001')
        } else {
          this.currentClubCode = this.$route.query.ccode
        }
        this.setClubInfo()
      }
      this.selectCcode = this.currentClubCode
      this.setData()
    })
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  mounted() {},
  computed: {
    isBatteryDataValid() {
      const batteryConditions = this.pinBatteryConditions
      if (!batteryConditions) return false
      if (batteryConditions.error) return false
      return true
    },
    pinBatteryConditions() {
      return this.aplCommBatteryData.battery || null
    },
    pinTotalHoleCount() {
      const courseList = this.aplCommBatteryData.courseList || []
      const lastHole = courseList[courseList.length - 1]
      if (lastHole) return lastHole.endIdx || ''

      const battery = this.pinBatteryConditions
      if (!battery || !battery.activeApl) return null
      return battery.activeApl.length
    },
    pinNormalCount() {
      return this.aplCommBatteryData.club.activeCount
    },
    pinAbnormalCount() {
      return this.aplCommBatteryData.club.inactiveCount
    },
    pinNormalOperationRate() {
      return this.Percentage(
        this.pinNormalCount,
        this.pinNormalCount + this.pinAbnormalCount
      )
    },
    pinSpareCount() {
      return this.aplCommBatteryData.club.idleCount
    },
    pinStandard() {
      return this.confirmPinSize(this.clubInfo.pin_size)
    },
    pinMethod() {
      return this.clubInfo.pin_change
    },
    pinConditions() {
      return {
        holeCount: this.pinTotalHoleCount,
        normalCount: this.pinNormalCount,
        abnormalCount: this.pinAbnormalCount,
        normalOperationRate: this.pinNormalOperationRate,
        spareCount: this.pinSpareCount,
        pinStandard: this.pinStandard,
        pinMethod: this.pinMethod
      }
    },
    isBatteryDataEmpty() {
      // Has data as array type?
      if (!this.aplBatteryList || !Array.isArray(this.aplBatteryList)) {
        return false
      }

      const isEmpty = this.aplBatteryList.every(course => {
        const isLeftEmpty = course.aplListL[0].every(item => !item)
        let isRightEmpty = false
        if (course.hasRight) {
          isRightEmpty = course.aplListR[0].every(item => !item)
        }
        // Has empty?
        return course.hasRight ? isLeftEmpty && isRightEmpty : isLeftEmpty
      })
      return isEmpty
    }
  },
  methods: {
    convertBatteryText(percent) {
      return percent >= 80 ? 'Full' : `${percent}%`
    },
    convertBatteryValue(percent) {
      return percent >= 80 ? 100 : `${percent}`
    },
    setData: async function() {
      await this.getPinConditions()
      settingService
        .getClubInfoDetail(this.currentClubCode)
        .then(response => {
          this.clubInfo = response.data.clubInfo
          this.clubInfo = response.data.clubInfo
          const holidayHoles = this.clubInfo.holiday_holes || ''
          const holidayHolesArr = holidayHoles.split(',')
          if (this.isBatteryDataValid) {
            const workHoles = this.aplCommBatteryData.battery.activeApl.filter(
              hole => !holidayHolesArr.includes(String(hole.hlidx + 1))
            )
            const normalHolesCount = workHoles.filter(hole => hole.isActive)
              .length
            this.currentActiveCount = normalHolesCount
            this.currentInactiveCount = workHoles.length - normalHolesCount
            this.currentHolidayHoleCount =
              this.aplCommBatteryData.battery.activeApl.length -
              workHoles.length
          }
        })
        .catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
    },
    async getPinConditions() {
      try {
        const { statusCode, data } = await gcsService.getAplCommBattery(
          this.currentClubCode
        )
        if (statusCode !== 200 || !data) {
          console.error('Failed getting pin condition info.')
        }
        const { battery, club } = data

        this.aplCommBatteryData = data
        this.isDataExist = club.setupCount
        if (battery.activeApl && Array.isArray(battery.activeApl)) {
          this.currentNHole = battery.activeApl[0]
            ? this.aplCommBatteryData.battery.activeApl[0].nhole
            : 0
        }
        this.currentActiveCount = club.activeCount
        this.currentInactiveCount = club.inactiveCount
        this.currentIdleCount = club.idleCount
        this.confirmTableStyle()
      } catch (e) {
        console.error(e)
      }
    },
    Percentage: function(data, sum) {
      return this.calcPercentage(data, sum)
    },
    setBarClass: function(holeIdx, percentage, angleError) {
      const holidayHoles = this.clubInfo.holiday_holes || ''
      const offClub = this.isTodayOff(this.clubInfo)
      const holidayHolesArr = holidayHoles.split(',')
      if (offClub && holidayHolesArr.includes(String(holeIdx + 1))) {
        return 'statusClosed'
      }
      if (angleError) return 'statusPinError'
      if (!percentage) return 'statusWarning'

      // Calibrate pertcent value. If the value greater than 80, express it as full charged.
      const calibratedValue =
        percentage >= 80 ? 100 : Math.round(percentage / 20) * 20

      return `battery-${calibratedValue}`
    },
    setBatteryClass: function(percentage) {
      let text = ''
      if (percentage === 100) {
        text = 'statusComplete'
      } else {
        text = 'statusCharging'
      }
      return text
    },
    confirmTableStyle: function() {
      this.aplBatteryList = []
      this.hasRight = 0
      this.idleList = []
      // 코스
      this.aplCommBatteryData.courseList.forEach(course => {
        const courseBattery = {
          name: course.name,
          colSpan: 1,
          rowSpan: 2,
          aplListL: [],
          aplListR: [],
          startIdx: course.startIdx,
          endIdx: course.endIdx,
          courseCycle: Math.ceil((course.endIdx - course.startIdx) / 9),
          hasRight: false
        }
        for (let i = 0; i < courseBattery.courseCycle; i++) {
          courseBattery.aplListL.push(new Array(9))
          courseBattery.aplListR.push(new Array(9))
        }

        if (this.isBatteryDataValid) {
          this.aplCommBatteryData.battery.activeApl.forEach(apl => {
            if (
              courseBattery.startIdx > apl.hlidx ||
              courseBattery.endIdx <= apl.hlidx
            ) {
              return
            }
            courseBattery[`aplList${apl.grsel}`][
              Math.floor((apl.hlidx - course.startIdx) / 9)
            ][apl.hlidx % 9] = apl
          })
        }

        courseBattery.hasRight =
          courseBattery.aplListR.filter(arr => arr.filter(el => el).length)
            .length && true
        courseBattery.rowSpan = 3 * courseBattery.courseCycle
        this.aplBatteryList.push(courseBattery)
      })
      if (this.aplBatteryList.find(courseBattery => courseBattery.hasRight)) {
        this.hasRight = 1
      }
      this.aplBatteryList = [...this.aplBatteryList]

      // 예비품
      if (this.isBatteryDataValid) {
        const idleList = this.aplCommBatteryData.battery.idleApl
        const idleCycle = Math.ceil(idleList.length / 9)
        for (let i = 0; i < idleCycle; i++) {
          this.idleList.push(new Array(9))
        }
        this.aplCommBatteryData.battery.idleApl.forEach((apl, i) => {
          this.idleList[Math.floor(i / 9)][i % 9] = apl
        })
        this.idleList = [...this.idleList]
      }
    }
  }
}
</script>
<style scoped>
.pin-conditions {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  margin: 20px -20px 0;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
}
.pin-conditions::before {
  content: '';
  padding: 10px;
}
.pin-conditions::after {
  content: '';
  padding: 10px;
}
div::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
.pin-conditions__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border-radius: 7px;
  overflow: hidden;
  box-shadow: 0 0 0 1px #ccc;
}
.pin-conditions .table__head {
  background-color: #202845;
  border-top: 1px solid #ccc;
}
.pin-conditions .table__head th {
  color: white;
  padding: 15px 75px;
  white-space: nowrap;
  border-right: 1px solid white;
  border-bottom: 1px solid #ccc;
}
.pin-conditions .table__head th:last-child {
  border-right: none;
}
.pin-conditions .table__body {
  background-color: white;
  border-bottom: 1px solid #ccc;
}
.pin-conditions .table__body td {
  text-align: center;
  padding: 15px 0;
  border-right: 1px solid #ccc;
}
.pin-conditions .table__body td:last-child {
  border-right: none;
}

.status.battery-20 .batteryGauge .battery .bar .item {
  width: 12px !important;
}
.status.battery-40 .batteryGauge .battery .bar .item {
  width: 24px !important;
}
.status.battery-60 .batteryGauge .battery .bar .item {
  width: 40px !important;
}
.status.battery-80 .batteryGauge .battery .bar .item {
  width: 50px !important;
}
.status.battery-100 .batteryGauge .battery .bar .item {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/clubdashboard/CD002.vue